import { useState, useEffect } from "react";
import { GetMocktestQuestion } from "../../../Client/request";
import { useContext } from "react";
import PteAttemptContext from "../PteAttemptContext";

export const useListeningQuestion = (quest, startStopwatch, cachedQuestionData = null) => {
  const attemptId = useContext(PteAttemptContext);
  const [questData, setQuestData] = useState(cachedQuestionData || null);
  const [loading, setLoading] = useState(!cachedQuestionData);

  useEffect(() => {
    if (quest) {
      setLoading(true);
      if (cachedQuestionData) {
        setQuestData(cachedQuestionData);
        setLoading(false);
        startStopwatch();
        return;
      }

      GetMocktestQuestion(quest.QuestionId, attemptId).then((res) => {
        if (res.data) {
          setQuestData(res.data);
          setLoading(false);
          startStopwatch();
        }
      });
    }
    // eslint-disable-next-line
  }, [quest, cachedQuestionData, attemptId]); // startStopwatch intentionally omitted to prevent re-renders

  return {
    questData,
    loading,
    setQuestData,
  };
};
